import { render, staticRenderFns } from "./Berusaha.vue?vue&type=template&id=11adba12&"
import script from "./Berusaha.vue?vue&type=script&lang=js&"
export * from "./Berusaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports